:root {
  color-scheme: dark;
  --bg: #030303;
  --ink: #f5efe6;
  --muted: #877f75;
  --acid: #caff29;
  --pink: #ff5bd6;
  --blue: #62e7ff;
  --orange: #ffb14a;
  --line: rgba(245, 239, 230, .15);
  font-family: "Courier New", ui-monospace, monospace;
}
* { box-sizing: border-box; }
body {
  margin: 0;
  min-height: 100vh;
  color: var(--ink);
  background:
    radial-gradient(circle at 74% 12%, rgba(255,91,214,.15), transparent 18rem),
    radial-gradient(circle at 12% 82%, rgba(98,231,255,.12), transparent 20rem),
    linear-gradient(180deg, #030303, #070604 58%, #020202);
}
body::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.028) 1px, transparent 1px);
  background-size: 24px 24px;
  mask-image: radial-gradient(circle at center, black, transparent 80%);
}
body::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  opacity: .14;
  background: repeating-linear-gradient(0deg, rgba(255,255,255,.05) 0 1px, transparent 1px 4px);
  animation: crt 4s linear infinite;
}
a { color: inherit; text-decoration: none; }
main { position: relative; z-index: 1; width: min(1280px, calc(100% - 24px)); margin: 0 auto; padding: 16px 0 48px; }
.legend, .action, .lane, .lead, .blog, .post, .notePage, .queue, .catEye {
  border: 1px solid var(--line);
  background: rgba(3,3,3,.68);
}
.hero {
  min-height: 30vh;
  display: grid;
  grid-template-columns: 1fr 260px;
  align-items: end;
  gap: 12px;
  padding: clamp(32px, 6vw, 72px) 0 12px;
}
.kicker { margin: 0 0 10px; color: var(--blue); font-size: 12px; text-transform: uppercase; letter-spacing: .16em; }
h1 {
  margin: 0;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(58px, 11vw, 142px);
  line-height: .72;
  letter-spacing: -.105em;
  text-transform: lowercase;
  text-shadow: 2px 0 var(--pink), -2px 0 var(--blue), 0 0 24px rgba(202,255,41,.12);
}
.sync { display: inline-block; margin-top: 18px; color: var(--muted); font-size: 11px; letter-spacing: .1em; text-transform: uppercase; }
.action { min-height: 174px; padding: 14px; display: grid; align-content: space-between; box-shadow: 0 0 50px rgba(202,255,41,.08); }
.action p { margin: 0; color: var(--pink); font-size: 12px; text-transform: uppercase; letter-spacing: .12em; }
.action b { color: var(--acid); font-size: 64px; line-height: .8; text-shadow: 0 0 18px rgba(202,255,41,.7); animation: blink 1.2s steps(2) infinite; }
.action span { color: var(--ink); font-size: 14px; }
.cockpit { display: grid; grid-template-columns: minmax(280px, 1fr) 420px; gap: 8px; margin-bottom: 8px; }
.catEye { position: relative; min-height: 190px; overflow: hidden; box-shadow: inset 0 0 80px rgba(202,255,41,.05); }
.catEye::before {
  content: "";
  position: absolute;
  inset: 22px 9%;
  border: 1px solid rgba(202,255,41,.35);
  border-radius: 50%;
  box-shadow: 0 0 34px rgba(202,255,41,.14), inset 0 0 30px rgba(98,231,255,.06);
}
.catEye::after {
  content: "";
  position: absolute;
  inset: 34px 49%;
  border-left: 1px solid rgba(255,91,214,.65);
  box-shadow: 0 0 22px rgba(255,91,214,.45);
  animation: scan 5.6s linear infinite;
}
.orb {
  --angle: calc((var(--i) * 57deg) - 18deg);
  position: absolute;
  left: var(--p);
  top: calc(50% + (sin(var(--angle)) * 54px));
  translate: -50% -50%;
  min-width: 42px;
  min-height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 999px;
  color: var(--acid);
  font-size: 12px;
  background: #050505;
  box-shadow: 0 0 20px rgba(202,255,41,.12);
}
.orb.momentum-hot { animation: pulse 1.35s ease-in-out infinite; border-color: rgba(202,255,41,.65); }
.orb.momentum-drift { color: var(--orange); animation: drift 5.8s ease-in-out infinite; opacity: .82; }
.orb.momentum-parked { color: var(--muted); animation: drift 6s ease-in-out infinite; }
.queue { margin: 0; padding: 10px; list-style: none; display: grid; gap: 8px; }
.queue li { display: grid; grid-template-columns: 44px 1fr; gap: 3px 10px; align-items: center; padding: 10px; border: 1px solid rgba(245,239,230,.1); background: rgba(255,255,255,.025); }
.queue span { color: var(--acid); font-size: 22px; text-shadow: 0 0 12px rgba(202,255,41,.5); }
.queue b { font-size: 13px; font-weight: 400; }
.queue em { grid-column: 2; color: var(--orange); font-size: 11px; font-style: normal; }
.lanes { display: grid; grid-template-columns: repeat(6, minmax(150px, 1fr)); gap: 8px; overflow-x: auto; padding-bottom: 6px; }
.lane { min-height: 396px; padding: 9px; display: flex; flex-direction: column; gap: 8px; }
.lane > span { color: var(--muted); font-size: 11px; text-transform: uppercase; letter-spacing: .12em; padding-bottom: 6px; border-bottom: 1px solid var(--line); }
.lead { position: relative; min-height: 214px; padding: 10px; display: flex; flex-direction: column; gap: 9px; overflow: hidden; transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease; }
.lead:hover { transform: translateY(-2px) skewX(-.4deg); border-color: rgba(202,255,41,.42); box-shadow: 0 0 26px rgba(202,255,41,.07); }
.lead::before { content: ""; position: absolute; inset: 0; opacity: .12; background: linear-gradient(135deg, var(--blue), transparent); pointer-events: none; }
.stage-discovery::before { background: linear-gradient(135deg, var(--acid), transparent); }
.stage-kickoff::before, .stage-delivery::before { background: linear-gradient(135deg, var(--pink), transparent); }
.stage-parked::before { background: linear-gradient(135deg, #777, transparent); }
.actNow { border-color: rgba(202,255,41,.42); }
.momentum-hot { box-shadow: 0 0 24px rgba(202,255,41,.08); }
.stage-parked { animation: drift 7s ease-in-out infinite; }
.leadTop { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.leadTop b { color: var(--acid); font-size: 18px; text-shadow: 0 0 12px rgba(202,255,41,.55); }
.leadTop span { color: var(--pink); }
.lead strong { min-height: 34px; font-size: 15px; font-weight: 400; line-height: 1.2; }
.track { height: 8px; border: 1px solid var(--line); background: #050505; }
.track i { display: block; height: 100%; background: linear-gradient(90deg, var(--blue), var(--acid)); box-shadow: 0 0 14px rgba(202,255,41,.5); }
.facts { display: grid; gap: 6px; margin: 0; }
.facts div { display: grid; grid-template-columns: 42px 1fr; gap: 8px; }
.facts dt { color: var(--muted); font-size: 10px; text-transform: uppercase; letter-spacing: .1em; }
.facts dd { margin: 0; color: var(--ink); font-size: 11px; line-height: 1.25; }
.facts div:nth-child(3) dd { color: var(--acid); }
.facts div:nth-child(4) dd { color: var(--blue); }
.facts div:nth-child(5) dd { color: var(--orange); }
.facts div:nth-child(6) dd { color: var(--blue); }
.legend { display: flex; flex-wrap: wrap; gap: 14px; margin-top: 8px; padding: 10px 12px; color: var(--muted); font-size: 12px; text-transform: uppercase; letter-spacing: .1em; }
.blog { margin-top: 8px; padding: 14px; }
.blogHead { display: flex; justify-content: space-between; align-items: end; gap: 12px; margin-bottom: 10px; }
.blog h2, .notePage h2 { margin: 0; font-family: Georgia, "Times New Roman", serif; font-size: clamp(34px, 6vw, 72px); line-height: .8; letter-spacing: -.08em; text-shadow: 1px 0 var(--pink), -1px 0 var(--blue); }
.posts { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
.post { min-height: 168px; padding: 12px; display: flex; flex-direction: column; justify-content: space-between; transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease; }
.post span, .stamp { color: var(--acid); font-size: 11px; text-transform: uppercase; letter-spacing: .12em; }
.post strong { font-size: 16px; font-weight: 400; color: var(--ink); }
.post p { margin: 0; color: var(--muted); font-size: 14px; line-height: 1.45; }
.post em { color: var(--pink); font-size: 11px; font-style: normal; text-transform: uppercase; letter-spacing: .12em; }
.post:hover { transform: translateY(-3px); border-color: rgba(202,255,41,.45); box-shadow: 0 0 24px rgba(202,255,41,.08); }
.overlay { position: fixed; inset: 0; z-index: 20; display: grid; place-items: center; padding: 18px; }
.backdrop { position: absolute; inset: 0; background: rgba(0,0,0,.74); backdrop-filter: blur(10px); }
.notePage { position: relative; width: min(760px, 100%); max-height: min(760px, calc(100vh - 36px)); overflow: auto; padding: clamp(18px, 4vw, 42px); box-shadow: 0 0 80px rgba(202,255,41,.12); }
.notePage::before { content: ""; position: absolute; inset: 0; pointer-events: none; border: 1px solid rgba(202,255,41,.24); transform: translate(8px, 8px); }
.close { position: absolute; top: 10px; right: 14px; color: var(--pink); font-size: 32px; line-height: 1; }
.notePage h2 { margin: 22px 0 26px; }
.notePage p { color: var(--ink); font-size: clamp(17px, 2.1vw, 21px); line-height: 1.65; max-width: 62ch; }
@keyframes blink { 50% { opacity: .35; } }
@keyframes crt { 50% { transform: translateY(2px); } }
@keyframes pulse { 50% { box-shadow: 0 0 34px rgba(202,255,41,.34); transform: scale(1.035); } }
@keyframes drift { 50% { transform: translateY(4px); opacity: .72; } }
@keyframes scan { 50% { transform: translateX(20px); opacity: .45; } }
@media (max-width: 980px) { .hero, .cockpit { grid-template-columns: 1fr; } .action { min-height: 120px; } .lanes { grid-template-columns: repeat(6, 180px); } .posts { grid-template-columns: 1fr; } .blogHead { display: block; } .catEye { min-height: 160px; } }
@media (prefers-reduced-motion: reduce) { *, *::before, *::after { animation: none !important; transition: none !important; } }
